<dx-drop-down-box
  fieldTemplate="tagField"
  [width]="width()"
  [value]="selectedItems().length || null"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [readOnly]="readOnly()"
  (onValueChanged)="onInputCleared($event)">

  <dxo-drop-down-options [wrapperAttr]="{class: 'yo-multiselect-popup popup-on-top'}">
  </dxo-drop-down-options>

  <div *dxTemplate="let _ of 'tagField'" class="yo-multiselect-field-tags" [class.yo-multiselect-field-tags--nowrap]="maxDisplayedTags() !== null">
    @for (item of visibleSelectedItemObjects(); track item[key()]) {
      <span class="yo-multiselect-tag">
        <span class="yo-multiselect-tag-label">{{ item[displayValue()] }}</span>
        @if (!disabled() && !readOnly()) {
          <button type="button" class="yo-multiselect-tag-remove"
                  (mousedown)="$event.stopPropagation()"
                  (click)="removeItem($event, item[key()])">×</button>
        }
      </span>
    }

    @if (hiddenCount() > 0) {
      <span class="yo-multiselect-tag">+{{ hiddenCount() }}</span>
    }

    <dx-text-box
      [readOnly]="true"
      stylingMode="text"
      [placeholder]="!selectedItemObjects().length ? placeholder() : ''"
    ></dx-text-box>
  </div>

  <div *dxTemplate="let _ of 'content'" class="yo-multiselect-content">
    <dx-tree-view
      #treeView
      [items]="treeData()"
      keyExpr="__treeId"
      parentIdExpr="__parentId"
      dataStructure="plain"
      [rootValue]="null"
      [displayExpr]="displayValue()"
      showCheckBoxesMode="normal"
      selectionMode="multiple"
      [selectNodesRecursive]="true"
      searchMode="contains"
      searchEnabled="true"
      [searchExpr]="searchExpr() ?? displayValue()"
      (onContentReady)="onTreeContentReady($event)"
      (onItemSelectionChanged)="onNodeSelectionChanged($event)">
    </dx-tree-view>
  </div>
</dx-drop-down-box>
